// vue app
import { createApp } from 'vue';
import App from './App.vue';

// styles
import '@/styles/ionic.ts';
import '@/styles/tailwind.css';
import '@/styles/variables.css';

// ionic
import { IonicVue } from '@ionic/vue';

// pinia, lang, router
import { createPinia } from 'pinia';
import { i18n } from './lang/i18n.ts';
import { initSentry } from './monitoring/sentry.ts';
import router from './router';

const pinia = createPinia();

const app = createApp(App)
    .use(IonicVue)
    .use(router)
    .use(i18n)
    .use(pinia);


router.isReady().then(() => {

    app.mount('#app');
});

initSentry(app);